var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 5.78798L16 0.470199L13.8879 2.58229L13.6512 2.34561C12.1408 0.83523 10.1327 0.00341797 7.99666 0.00341797C3.58725 0.00338672 0 3.5907 0 8.00004C0 12.4094 3.58725 15.9967 7.99666 15.9967C12.4061 15.9967 15.9933 12.4094 15.9933 8.00004H14.4455C14.4455 11.556 11.5526 14.4489 7.99662 14.4489C4.44069 14.4489 1.54775 11.556 1.54775 8.00004C1.54775 4.44411 4.44072 1.55114 7.99666 1.55114C9.71928 1.55114 11.3387 2.22198 12.5568 3.44004L12.7935 3.67673L10.6816 5.78861L15.9987 5.78798Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.51086bab7a1dff17487bb4ff312a4aad.svg";
export { ForwardRef as ReactComponent };